import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import NO_RESULTS from '../../utils/constants/no-results'
import './tags.css'

interface Blobs {
  fileName: string
}
interface Attachment {
  blobs: Blobs[]
}
interface InnerViewItems {
  Attachments: Attachment[]
  assignComponentCode: number
  categoryCode: number
  content: string
  eKey: string
  extra: string
  id: number
  link: string
  majcomCode: number
  postedDate: string
  section: string
  sectionCode: number
  subcontent: string
  subcontent1: string
  tags: string
  title: string
}

interface TagProps {
  intialItems: InnerViewItems[]
  isTagActive?: boolean
  setFilteredTagItems: React.Dispatch<
    React.SetStateAction<InnerViewItems[]>
  >
}
interface Tags {
  id: number
  link: string
  title: string
}

const TagsCloud = ({
  intialItems,
  isTagActive,
  setFilteredTagItems,
}: TagProps) => {
  const tagDataArr: any =
      intialItems
        ?.filter((item) => (item?.tags && item?.tags.length > 0 && item?.tags[0] !== ''))
        .map((item) => item.tags)
  const tagData: any[] = []

  tagDataArr.forEach((tagArr) => {
    tagArr.forEach((tag) =>{
      tagData.push(tag.trim())})
  })

  const tagsdata: Tags[] = [...new Set(tagData)].map((tag, i) => ({
    id: i,
    link: '#',
    title: tag,
  }))

  const [selectedTag, setSelectedTag] = useState<Array<string>>([])
  const [activeIndex, setActiveIndex] = useState<{ [key: string]: boolean }>()
  useEffect(() => {
    setActiveIndex({})
  }, [isTagActive])

  const onTagsClick = (tags: Tags) => {
    let allSelectedTags: string[]

    if (selectedTag.includes(tags.title)) {
      setActiveIndex((prev) => ({
        ...prev,
        [tags.title]: false,
      }))
      allSelectedTags = selectedTag.filter((t) => t !== tags.title)
    } else {
      setActiveIndex((prev) => ({
        ...prev,
        [tags.title]: true,
      }))
      allSelectedTags = [...selectedTag, tags.title]
    }

    const tagAnnouncements =
      allSelectedTags.length === 0
        ? intialItems
        : intialItems.filter((item) => {
          return allSelectedTags.some((tag) => item.tags.includes(tag))
        })
    setSelectedTag(allSelectedTags)
    setFilteredTagItems(tagAnnouncements)
  }
  function onClear() {
    setSelectedTag([])
    setActiveIndex({})
    setFilteredTagItems(intialItems)
  }
  return (
    <>
      <div className='d-flex align-items-center p-0 px-2 card-header border-bottom1'>
        <div className='d-flex'>
          <div
            aria-label='Tag Cloud'
            className='poppins-semibold font-13 title-color'
            tabIndex={0}
          >
            Tag Cloud
          </div>
        </div>
        <div className='ms-auto'>
          <Link
            className='btn btn-sm links ms-auto ms-sm-0 ms-md-0 text-nowrap links-underline p-0'
            onClick={onClear}
            title='Clear'
            to='#'
          >
            Clear
          </Link>
        </div>
      </div>
      <div className='d-flex flex-column card-body pt-0'>
        <div className='mt-3 tags'>
          <ul className='list-type-none'>
            {tagsdata.length === 0 ? (
               <div>
               <NO_RESULTS/>
               </div>
            ) : (
              tagsdata.map((tags) => (
                <li className='d-inline-block' key={tags.title}>
                  <Link
                    className={`font-11 ${activeIndex[tags.title] ? 'bgcolor-primary whitetext' : ''
                      } poppins-semibold btn-border-radius3 p-relative mx-1 px-3 py-2 mb-2`}
                    onClick={() => onTagsClick(tags)}
                    title={tags.title}
                    to={tags.link}
                  >
                    {defaultToEmptyString(tags.title)}
                  </Link>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </>
  )
}
export default TagsCloud
